export const EMPTY = "activation.homepage.widget.my_traffic_share.empty";
